import { Card } from 'antd';
import Meta from 'antd/lib/card/Meta';
import React from 'react';
import styled from 'styled-components';
import { ReactComponent as Attached } from '../../../images/dontatacched.svg';
import { ReactComponent as Undef } from '../../../images/lock-undf-open.svg';
import { ReactComponent as OpenLockBlue } from '../../../images/lock_blue_open.svg';
import { ReactComponent as NotAvalibleLock } from '../../../images/lock_gray_close.svg';
import { ReactComponent as AvalibleLock } from '../../../images/lock_green_close.svg';
import { ReactComponent as OpenGreenLock } from '../../../images/opengreenlock.svg';

const Number = styled.div`
  &&& {
    bottom: 1px;
    left: 3px;
  }
`;

function Box({
  avalibale,
  openAdmin,
  openUser,
  notAttached,
  notAvalibale,
  name,
  expired,
  undef,
}) {
  return (
    <div className="pr-6 pb-6">
      <Card
        className={`${
          notAttached ? 'bg-white' : 'bg-bluebox'
        } w-80 h-80 flex items-center justify-center relative text-graytext hover:shadow-boxShadowHover`}
        hoverable={true}
        
      >
        {/* <Meta
          description={name}
        /> */}
        <div
          className={
            expired
              ? 'rounded-full border-red border-2 h-40 w-40 flex items-center justify-center'
              : null
          }
        >
          {avalibale ? (
            <AvalibleLock />
          ) : openAdmin ? (
            <OpenGreenLock />
          ) : openUser ? (
            <OpenLockBlue />
          ) : notAvalibale ? (
            <NotAvalibleLock />
          ) : notAttached ? (
            <Attached />
          ) : undef ? (
            <Undef />
          ) : null}
          <Number className="number absolute pl-1">{name}</Number>
        </div>
      </Card>
    </div>
  );
}

Box.propTypes = {};

export default Box;
